import produce from 'immer';

// TYPES
import { Types, CadastrarTipos } from './types';
import { ReducerAction } from '../../../../../../types';

export const INITIAL_STATE: CadastrarTipos = {
	status: 0,
	data: null,
};

export default function cadastrarTiposReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): CadastrarTipos {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRAR_TIPOS: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CADASTRAR_TIPOS_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CADASTRAR_TIPOS_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CADASTRAR_TIPOS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
